import colorsVars from 'styles/colors.module.scss';
import { TooltipCellWithCopy } from 'components/common/Tables/Cells/tooltipCellWithCopy';
import { columnsCommonConfig } from 'components/common/Tables/columnsCommonConfig';
import { Pills } from 'components/common/pills/pills';
import moment from 'moment-timezone';
import constants from 'components/common/Constants/constants';
import React from 'react';
import { ActivityCell } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/relationships/relationships.utils';
import { ITableColumnState } from 'hooks/useTableCurrentState';

const { color8: orange, delayDriverColor, lightTableText } = colorsVars;

export const initialState: ITableColumnState = {
    sortBy: [
        {
            id: 'startDate',
            desc: true,
        },
    ],
    hiddenColumns: ['durationOverrun', 'criticalityScore'],
};

export const columns = [
    {
        Header: 'Activity ID',
        accessor: 'activityCode',
        isDisableReorder: true,
        isDisableVisibility: true,
        Cell: ({ value }) => <TooltipCellWithCopy text={value} showAlways={true} />,
    },
    {
        Header: 'Activity Name ',
        accessor: 'activityName',
        isDisableReorder: true,
        isDisableVisibility: true,
        Cell: ({ value, row }) => <ActivityCell row={row} value={value} />,
    },

    {
        Header: 'Start Variance',
        accessor: 'startVariance',
        ...columnsCommonConfig.lateStart,
        Cell: ({ value, row }) => {
            const { activityStatus } = row.original;
            if (activityStatus === 'To Do' && value > 0) {
                return <Pills type={'risk'}>{value}</Pills>;
            }

            return <span style={{ color: lightTableText }}>{value}</span>;
        },
    },
    {
        Header: 'Finish Variance',
        accessor: 'finishVariance',
        ...columnsCommonConfig.lateFinish,
        Cell: ({ value, row }) => {
            const { activityStatus } = row.original;
            if ((activityStatus === 'In Progress' || activityStatus === 'To Do') && value > 0) {
                return <Pills type={'tableRisk'}>{value}</Pills>;
            }

            const color = activityStatus === 'Done' && value > 0 ? orange : lightTableText;
            return <span style={{ color }}>{value}</span>;
        },
    },
    {
        Header: 'Start Date',
        accessor: 'startDate',
        sortType: 'basic',
        Cell: ({ value }) => {
            return <span>{moment(value).format(constants.formats.date.default)}</span>;
        },
    },
    {
        Header: 'Finish Date',
        accessor: 'finishDate',
        sortType: 'basic',
        Cell: ({ value }) => {
            return <span>{moment(value).format(constants.formats.date.default)}</span>;
        },
    },
    {
        Header: 'Duration Overrun',
        accessor: 'durationOverun',
        ...columnsCommonConfig.durationOverrun,
        Cell: ({ value }) => {
            const color = value > 0 ? orange : lightTableText;
            return <span style={{ color }}>{value}</span>;
        },
    },
    {
        Header: 'Criticality Score',
        accessor: 'criticalityScore',
        ...columnsCommonConfig.criticalityScore,
        Cell: ({ value, row }) => {
            const delayDriver = row.original.delayDriver;
            const color = delayDriver ? delayDriverColor : lightTableText;
            return <span style={{ color }}>{value}</span>;
        },
    },
    {
        Header: 'Critical Path',
        ...columnsCommonConfig.criticalPath,
        accessor: (row) => (row.criticalPath ? 'Yes' : 'No'),
    },
];
